import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Dashboard.css";
import { Link } from "react-router-dom";

function FullAuctionDashboard() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const pageSize = 10;

  const fetchProducts = async (pageNum = 1) => {
    try {
      const res = await axios.get(`https://api.herracim.az/api/dashboard/full-auction-info?page=${pageNum}&pageSize=${pageSize}`, {
        withCredentials: true,
      });

      if (pageNum === 1) {
        setProducts(res.data.products);
      } else {
        setProducts(prev => [...prev, ...res.data.products]);
      }

      setTotalCount(res.data.totalCount);
      setHasMore(res.data.products.length === pageSize);
    } catch (err) {
      console.error("❌ Məlumatlar alınarkən xəta baş verdi:", err);
    } finally {
      setLoading(false);
      setIsLoadingMore(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const loadMoreProducts = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    setIsLoadingMore(true);
    fetchProducts(nextPage);
  };

  if (loading) return <p>Yüklənir...</p>;

  return (
    <div className="dashboard-container">
      <h1>💼 Bütün Hərrac Məhsulları</h1>
      <h3>Ümumi məhsul sayı: {totalCount}</h3>
      <table className="product-table">
        <thead>
          <tr>
            <th>Şəkil</th>
            <th>Ad</th>
            <th>Qiymət</th>
            <th>Yaradılma</th>
            <th>Son tarix</th>
            <th>Şəhər</th>
            <th>Status</th>
            <th>Ən yüksək təklif</th>
            <th>Satıcı</th>
            <th>Depozit</th>
            <th>Təsdiq</th>
            <th>Şikayət</th>
          </tr>
        </thead>
        <tbody>
          {products.map(product => (
            <tr key={product.id}>
              <td>
                <Link to={`/elanlar/${product.categoryName}/${product.subCategoryName}/${product.id}`}>
                  <img src={`https://api.herracim.az/HerracImages/${product.imageUrl}`} width={60} alt={product.name} />
                </Link>
              </td>
              <td>{product.name}</td>
              <td>{product.price} AZN</td>
              <td>{new Date(product.createdAt).toLocaleDateString()}</td>
              <td>{product.endDate ? new Date(product.endDate).toLocaleDateString() : "-"}</td>
              <td>{product.city}</td>
              <td>{product.currentPrice > 0 ? "Aktiv" : "Passiv"}</td>
              <td>
                {product.highestBid ? (
                  <>
                    <b>{product.highestBid.fullName}</b> ({product.highestBid.amount} AZN)
                  </>
                ) : "Yoxdur"}
              </td>
              <td>
                {product.seller ? (
                  <>
                    {product.seller.fullName}<br />
                    <a href={`tel:${product.seller.phoneNumber}`}>{product.seller.phoneNumber}</a>
                  </>
                ) : "-"}
              </td>
              <td>
                {product.deposits.length > 0 ? (
                  <>
                    {product.deposits.map((d, i) => (
                      <div key={i}>{d.depositAmount} AZN ({d.isRefunded ? "Geri" : "Yox"})</div>
                    ))}
                  </>
                ) : "Yoxdur"}
              </td>
              <td>{product.isConfirmed ? "✅" : "❌"}</td>
              <td>{product.hasReport ? "⚠️" : "❌"}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {hasMore && (
        <div className="load-more-container">
          <button onClick={loadMoreProducts} className="load-more-btn">
            {isLoadingMore ? "Yüklənir..." : "Daha çox yüklə"}
          </button>
        </div>
      )}
    </div>
  );
}

export default FullAuctionDashboard;
